import { styled } from "theme/default/styled";

export const SForgotPasswordSendButtonLoader = styled.div`
  margin-top: 10px;
`;
